import { date } from "./format";

const LEGAL_FORMS = {
  SARL: "Société à Responsabilité Limitée (SARL)",
  EURL: "Entreprise Unipersonnelle à Responsabilité Limitée (EURL)",
  SPA: "Société par Actions (SPA)",
};

function legalFormFor(raison = "") {
  const sigle = Object.keys(LEGAL_FORMS).find((s) => raison.toUpperCase().endsWith(s));
  return LEGAL_FORMS[sigle] || LEGAL_FORMS.SARL;
}

function countryFor(tel = "") {
  if (tel.startsWith("+216")) return { nationality: "Tunisienne", bank: "Banque de Tunisie" };
  if (tel.startsWith("+212")) return { nationality: "Marocaine", bank: "Attijariwafa Bank" };
  return { nationality: "Algérienne", bank: "Banque Extérieure d'Algérie" };
}

function addYears(iso, years) {
  const d = new Date(iso);
  d.setFullYear(d.getFullYear() + years);
  return date(d.toISOString());
}

function numericIdOf(id = "") {
  return id.replace(/\D/g, "");
}

export function deriveEstablishmentKyc(e) {
  const numericId = numericIdOf(e.id);
  const { nationality, bank } = countryFor(e.tel);

  return {
    company: {
      legalName: e.raison,
      legalForm: legalFormFor(e.raison),
      ice: `ICE-${numericId}00`,
      taxIdentifier: `IF-${numericId}`,
      professionalTax: `TP-${numericId}`,
      rcNumber: `${numericId} RC`,
      registeredOffice: e.adresse,
      licenseNumber: `LIC-${numericId}`,
      licenseIssueDate: date(e.inscription),
      insurance: {
        company: "Assurances Zorni Voyage",
        policyNumber: `POL-${numericId}`,
        expiryDate: addYears(e.inscription, 1),
      },
      activities: e.activities || [],
    },
    governance: {
      manager: e.responsable,
      nationality,
      ownershipPercentage: 100,
      identityDocumentType: "Carte d'identité nationale (CIN)",
      identityNumber: `${numericId}K`,
      identityExpiryDate: addYears(e.inscription, 5),
      professionalEmail: e.email,
    },
    finance: {
      bankName: bank,
      accountHolder: e.raison,
      rib: `007 999 ${numericId.padStart(10, "0")} 45`,
    },
  };
}

export default deriveEstablishmentKyc;
